import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-2">
            <h3 className="font-heading text-xl font-semibold text-background-50 mb-4">Serenity</h3>
            <p className="text-background-300 text-sm leading-relaxed max-w-md">
              致力于为女性提供专业、私密、值得信赖的情趣用品信息与选购指导。我们相信，了解并悦纳自己的身体是每个女性应有的权利。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-medium text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-background-300 text-sm hover:text-background-100 transition-colors">首页</Link></li>
              <li><Link to="/category/vibration-clamps" className="text-background-300 text-sm hover:text-background-100 transition-colors">分类浏览</Link></li>
              <li><Link to="/article/top-10-clitoral-clamps-2026" className="text-background-300 text-sm hover:text-background-100 transition-colors">选购指南</Link></li>
              <li><Link to="/about" className="text-background-300 text-sm hover:text-background-100 transition-colors">关于我们</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-medium text-background-50 mb-4">热门文章</h4>
            <ul className="space-y-2">
              <li><Link to="/article/clitoral-clamp-beginners-guide" className="text-background-300 text-sm hover:text-background-100 transition-colors">入门指南</Link></li>
              <li><Link to="/article/clitoral-clamp-material-guide" className="text-background-300 text-sm hover:text-background-100 transition-colors">材质全解析</Link></li>
              <li><Link to="/article/clitoral-clamp-safety-myths" className="text-background-300 text-sm hover:text-background-100 transition-colors">安全须知</Link></li>
              <li><Link to="/article/couple-clitoral-clamp-play" className="text-background-300 text-sm hover:text-background-100 transition-colors">情侣玩法</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-background-700 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-400 text-xs">
            &copy; {new Date().getFullYear()} Serenity. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-background-400 text-xs hover:text-background-200 transition-colors" rel="nofollow">隐私政策</a>
            <a href="#" className="text-background-400 text-xs hover:text-background-200 transition-colors" rel="nofollow">使用条款</a>
            <Link to="/about" className="text-background-400 text-xs hover:text-background-200 transition-colors">联系我们</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}